<style lang="scss" scoped>
@include component(filter) {
	position: relative;
	padding: 20px 40px;
	border-bottom: 1px solid #eee;
	@include flex-center;
	@include part(setting) {
		display: block;
		margin-left: 0 !important;
		margin-bottom: 10px;
	}
	@include part(button) {
		border: 1px dashed #dcdfe6;
		font-weight: 600;
	}
	@include part(input) {
		border: 0;
		width: 100%;
		display: inline;
		&:focus {
			outline: 0;
		}
	}
	@include part(selected) {
		list-style: none;
		margin: 0;
		padding: 0;
		display: inline-block;
		white-space: nowrap;
		li {
			cursor: pointer;
			display: inline-block;
			height: 42px;
			line-height: 42px;
			padding-left: 20px;
			padding-right: 20px;
			background: #dcdfe6;
			color: black;
			font-size: 14px;
			border-radius: 20px;
			margin-right: 10px;
			&:last-child {
				margin-right: 5px;
			}
		}
	}
	@include part(options) {
		position: absolute;
		background-color: #fff;
		border: 1px solid rgba(0, 0, 0, 0.2);
		-webkit-box-shadow: 0 2px 3px #bdbdbd;
		box-shadow: 0 2px 3px #bdbdbd;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		font-size: 15px;
		left: auto;
		right: auto;
		min-width: 400px;
		top: 75px;
		z-index: 300;
		list-style: none;
		margin: 0;
		padding: 0;
		li {
			line-height: 40px;
			padding: 0 16px;
			cursor: pointer;
			// &:hover,
			&.selected {
				background: #eee;
			}
		}
	}
}
</style>
<style lang="scss">
.el-dialog__body {
	padding: 0px 20px;
	color: #606266;
	font-size: 14px;
	max-height: 600px;
	overflow-y: auto;
}
.filter {
	&__setting {
		width: 100%;
	}
}
</style>
<template>
    <div v-click-outside="clickOut" class="filter">
        <global-events @keydown.esc="hideOptions = true" />
		<el-button v-if="(providerCode === 'gapps' || providerCode === 'msft') && this.showReconnect" type="primary" @click="reconnect" round icon="fe fe-refresh-cw fe-just-off">Reconnect</el-button>
        <el-button v-if="!filtersActive" class="filter__button filter-btn" @click="activateFilters" round icon="fe fe-plus fe-just-off filter-btn"><span class="filter-btn">Filter / Search</span></el-button>
		<template v-else>
            <div class="filter__active">
                <ul class="filter__selected">
                    <li v-for="row in active" :key="row.path">{{ row.name }}: {{ row.type === 'text' ? row.filter_type : "" }} "{{ row.value }}"
                        <i @click="removeActive(row)" class="fe fe-x"></i>
                    </li>
                </ul>
                <ul v-if="includeInDropDown.length && hideOptions == false" class="filter__options">
                    <li v-for="field in includeInDropDown" :key="field.path" @click="finalize(null, field)" v-bind:class="{'selected' : field.selected }">{{ fieldText(field) }}</li>
                </ul>
            </div>
            <input ref="searchField" :placeholder="includeInDropDown.length ? 'Type or select filter' : '' " autocomplete="off" name="aasa33kk3k3k33dd" @click="focusInput" @focus="focusInput" @keydown.delete="deletePress" @keydown.down="down" @keydown.enter="finalize" @keydown.up="up" type="text" v-model="search" class="filter__input">
            <el-dialog class="filter__modal" v-if="selected" :title="selected.name" :visible.sync="dialogVisible" width="400px">
                <el-form @submit.prevent.native="confirmModal">
					<el-form-item label="Filter type" v-if="selected.type == 'text'">
						<el-select v-model="filterType">
							<el-option value="starts_with" label="Starts with"></el-option>
							<el-option value="contains" label="Contains"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item v-if="selected.type == 'text'" label="Search text">
                        <el-input ref="modalInput" v-model="modalValue"></el-input>
                    </el-form-item>
					<el-form-item v-if="selected.options && selected.options.length > 10" :label="`Search ${selected.path}`">
                        <el-input v-model="optionsFilter"></el-input>
                    </el-form-item>
                    <el-radio class="filter__setting" border v-for="row in filteredOptions" :key="row.path" v-model="modalValue" :label="row.value">{{row.label}}</el-radio>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="medium" style="margin-top:-10px" @click="cancelModal">Cancel</el-button>
                    <el-button size="medium" style="margin-top:-10px" type="primary" @click="confirmModal">Confirm</el-button>
                </span>
            </el-dialog>
        </template>
    </div>
</template>
<script>
import _ from "lodash";
import ClickOutside from "vue-click-outside";
export default {
	data() {
		return {
			filtersActive: false,
			search: null,
			dialogVisible: false,
			modalValue: null,
			modalValueContains: null,
			hideOptions: true,
			fields: [],
			filterType: "starts_with",
			optionsFilter: ""
		};
	},

	directives: {
		ClickOutside
	},

	props: {
		filterFields: {
			required: true,
			type: Array
		},
		remember: {
			required: false,
			type: Boolean,
			default: false
		},
		showReconnect: {
			required: false,
			type: Boolean,
			default: true
		},
		isOrg: {
			required: false,
			type: Boolean,
			default: false
		}
	},

	events: {
		"filter-set"(state) {
			// This is the event bus event for changing the filter from other components
			const found = _.find(this.fields, { name: "State" });
			if (state === "none") {
				this.$set(found, "value", null);
			} else {
				this.$set(found, "value", state);
			}
		}
	},

	watch: {
		active: {
			deep: true,
			handler() {
				let result = {};
				_.each(this.active, active => {
					result[active.path] = {
						filter_type: active.filter_type,
						value: active.value
					};
				});
				
				this.$emit("input", result);

				if (window.localStorage && this.remember) {
					localStorage.setItem(`${this.$router.currentRoute.name}-filter`, JSON.stringify(this.fields));
				}
				
				if (window.localStorage) {
					localStorage.setItem('isOrg', this.isOrg)
				}
			}
		}
	},

	mounted() {
		if (this.remember) {
			const storedFilter = localStorage.getItem(`${this.$router.currentRoute.name}-filter`);
			if (storedFilter) {
				this.fields = _.uniqBy(JSON.parse(storedFilter), "name");
				this.filtersActive = !!this.active.length;
			} else {
				this.fields = this.filterFields;
			}
		} else {
			this.fields = this.filterFields;
		}
	},

	computed: {
		active() {
			return _.filter(this.fields, f => f.value && f.value.length);
		},
		selected() {
			return _.find(this.fields, { selected: true });
		},
		filteredOptions() {
			return _.filter(this.selected.options, (option) => option.label.toLowerCase().includes(this.optionsFilter.toLowerCase()));
		},
		includeInDropDown() {
			if (this.search) {
				return _.filter(_.filter(this.fields, { type: "text" }), f => !f.value);
			} else {
				return _.filter(this.fields, f => !f.value);
			}
		}
	},

	methods: {
		finalize(event, field) {
			let selected = event == null ? field : this.selected;
			this.$set(selected, "selected", true);
			if (selected) {
				if (this.search) {
					this.$set(selected, "value", this.search);
					this.search = null;
					this.unselectAll();
					this.focus();
				} else {
					this.dialogVisible = true;
					this.$nextTick(() => {
						if (this.$refs.modalInput) this.$refs.modalInput.focus();
					});
				}
			}
		},
		up() {
			let selected = _.find(this.includeInDropDown, { selected: true });
			if (selected) {
				let previous = this.includeInDropDown[this.includeInDropDown.indexOf(selected) - 1];
				if (previous) {
					this.$set(selected, "selected", false);
					this.$set(previous, "selected", true);
				} else {
					this.$set(selected, "selected", false);
					this.$set(this.includeInDropDown[this.includeInDropDown.length - 1], "selected", true);
				}
			} else {
				this.$set(this.includeInDropDown[0], "selected", true);
			}
		},
		down() {
			let selected = _.find(this.includeInDropDown, { selected: true });
			if (selected) {
				let next = this.includeInDropDown[this.includeInDropDown.indexOf(selected) + 1];
				if (next) {
					this.$set(selected, "selected", false);
					this.$set(next, "selected", true);
				} else {
					this.$set(selected, "selected", false);
					this.$set(this.includeInDropDown[0], "selected", true);
				}
			} else {
				this.$set(this.includeInDropDown[0], "selected", true);
			}
		},
		clickOut(evt) {
			if (evt.target.classList.contains("filter-btn")) {
				this.filtersActive = true;
			} else if(this.active.length) {
				this.hideOptions = true;
			} else {
				this.hideOptions = true;
				this.filtersActive = false;
			}
		},
		activateFilters() {
			this.filtersActive = true;
			this.hideOptions = false;
			this.focus();
		},
		reconnect() {
			this.$router.push({ name: "connect.reconnect" });
		},
		focusInput() {
			this.hideOptions = false;
		},
		cancelModal() {
			this.dialogVisible = false;
			this.modalValue = null;
			this.selected.selected = false;
			this.focus();
			this.unselectAll();
		},
		confirmModal() {
			this.$set(this.selected, "value", this.modalValue);
			this.$set(this.selected, "filter_type", this.filterType);
			this.modalValue = null;
			this.modalValueContains = null;
			this.dialogVisible = false;
			this.selected.selected = false;
			this.focus();
			this.unselectAll();
		},
		removeActive(row) {
			row.value = null;
			row.selected = false;
			this.focus();
		},
		deletePress() {
			if (!this.search) {
				let next = _.last(this.active);
				if (next) {
					next.value = null;
				}
			}
		},
		fieldText(field) {
			if (!this.search) {
				return field.name;
			} else {
				return `${field.name} starts with "${this.search}"`;
			}
		},
		focus() {
			this.$nextTick(() => {
				this.$refs.searchField.focus();
			});
		},
		unselectAll() {
			_.each(this.fields, f => {
				this.$set(f, "selected", false);
			});
		}
	}
};
</script>
